import { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export const useApplyProgress = (isProcessing: boolean): number => {
  const [progress, setProgress] = useState(0);
  const { getValues } = useFormContext();

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (isProcessing) {
      const totalCount =
        Object.values(getValues()).filter((v) => v).length || 0;
      // logic to calculate approximate progress
      const delay = Math.min(0.15 + totalCount * 0.01, 2);
      timer = setInterval(() => {
        setProgress((val) => (val <= 90 ? val + 5 : val));
      }, delay * 1000);
    } else {
      setProgress(0);
    }

    return () => {
      clearInterval(timer);
    };
  }, [getValues, isProcessing]);

  return progress;
};
